export default __webpack_public_path__ + "7cc8ca4447d234967974ba16e2993a75.svg";